"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAPIErrorResponse = void 0;
function isAPIErrorResponse(object) {
    return (object.code !== undefined &&
        object.message !== undefined);
}
exports.isAPIErrorResponse = isAPIErrorResponse;
//# sourceMappingURL=APIErrorResponse.js.map